import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'business-request-demo',
    imports: [],
    templateUrl: './request-demo.component.html',
    styleUrl: './request-demo.component.scss'
})
export class BusinessRequestDemoComponent {
    assetUrl = environment.assetBaseUrl
}
